import React from "react";
import { Dispatch } from "@reduxjs/toolkit";
import { NavigateFunction } from "react-router-dom";
import { setParticipant } from "../store/participant/participantSlice";
import { NotFoundType } from "../pages/NotFound.page";
import { Conference, Language, Status } from "../types/conference.types";

interface UsePreviewSideEffectsParams {
  i18n: { activate: Function };
  congressEvent: Conference | null;
  isPreviewPage: boolean;
  isError: boolean;
  navigate: NavigateFunction;
  dispatch: Dispatch;
  isSuccessRegistration: boolean;
  registrationResult: { id?: number } | undefined;
}

export const usePreviewSideEffects = ({
  i18n,
  congressEvent,
  isPreviewPage,
  isError,
  navigate,
  dispatch,
  isSuccessRegistration,
  registrationResult,
}: UsePreviewSideEffectsParams) => {
  React.useEffect(() => {
    if (congressEvent) {
      const language = congressEvent.language === Language.ENGLISH ? "en" : "hu";
      i18n.activate(language);
    }
  }, [i18n, congressEvent]);

  React.useEffect(() => {
    if (isPreviewPage && congressEvent) {
      const language =
        congressEvent.language === Language.HUNGARIAN ? "hu" : "en";
      switch (congressEvent.status) {
        case Status.INACTIVE:
          navigate(`/notfound/${language}/${NotFoundType.Unavailable}`);
          break;
        case Status.FINISHED:
          navigate(`/notfound/${language}/${NotFoundType.Closed}`);
          break;
      }
    }
    if (isPreviewPage && isError) {
      navigate(`/notfound/hu/${NotFoundType.NotFound}`);
    }
  }, [congressEvent, isPreviewPage, navigate, isError]);

  React.useEffect(() => {
    if (isSuccessRegistration && registrationResult && registrationResult.id) {
      dispatch(setParticipant(registrationResult as any));
      navigate(`/success-registration/${registrationResult.id}`);
    }
  }, [dispatch, isSuccessRegistration, navigate, registrationResult]);
};

